import api from '@http/api';

export interface IDoacoes {
  modelo: IDoacoesResultTable[];
  idDoacao: number;
  dataCadastro: string;
  IDCadastro: number;
  NomeCadastro: string;
  Valor: string;
  origemDoacaoDescricao: string;
}

export interface IDoacoesResultTable {
  idDoacao: string;
  IDCadastro: string;
}

class Services {
  public async GetLotesFechados(status: number) {
    return await api
      .get('/api/LoteDoacao/lotes-fechados-usuario', {
        params: { status},
      })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }


  public async GetDoacoesPorLote(idLote: number) {
    return await api
      .get('/api/LoteDoacao/PendentesPorLote', {
        params: { idLote },
      })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async gerarRelatorio(idLote: number): Promise<{ error: boolean; response?: Blob }> {
    return await api
      .get(`/api/LoteDoacao/LotePdfFechado`, {
        params: { idLote },
        responseType: 'blob',
      })
      .then(response => ({
        error: false,
        response: response.data,
      }))
      .catch(() => ({ error: true }));
  }
}

export default new Services();
